import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { inject, injectable } from "tsyringe";

import { autoBind } from "src/shared/decorators/autobind";
import { LifeInfo } from "src/shared/models/life-info.model";
import { PgaPolicy } from "src/shared/models/pga-policy.model";
import { LifeRepository } from "src/containers/life/repositories/life/life-repository";

@injectable()
class LifeService {
    constructor(@inject("LifeRepository") private repository: LifeRepository) {}

    @autoBind
    getInfo(userIdentity: string, policy: PgaPolicy): Observable<LifeInfo> {
        return this.repository
            .getInfo(userIdentity, policy)
            .pipe(map((info) => LifeInfo.fromJson<LifeInfo>(info)));
    }
}

export { LifeService };
